module.exports = "/images/Sell Party and group sales.svg?f6e807fa4375c81fccdd6680b71b3cfc";